export const documentThemeStylesPath = 'assets/document-theme-styles';
